import { Backdrop, CircularProgress } from '@mui/material';

interface Props {
    enabled: boolean
}

export default (props: Props) => {
    return (
        <Backdrop
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={props.enabled}
        >
            <CircularProgress color="inherit" />
        </Backdrop>
    )
};